<div class="modal-header justify-content-between align-items-center">
  <h5 class="modal-title" id="modal-basic-title">Visualizar mascota</h5>
  <button
    type="button"
    class="modal-close close"
    aria-label="Close"
    (click)="activeModal.dismiss()"
  >
    <span class="material-symbols-rounded">close</span>
  </button>
</div>
<div class="modal-body">
  <img [src]="src" class="img-fluid w-100" alt="Documento" />
</div>
